module.exports = __webpack_public_path__ + "img/social.fdcfa24.png";